<div class="user-hover-trigger" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()">
  <app-profile-avatar
    [fullName]="fullName"
    [profileUrl]="profileUrl"
    [widthSize]="avatarSize"
    [heightSize]="avatarSize"
    [userStatusSlug]="statusSlug"
    >
  </app-profile-avatar>
</div>

@if (showCard) {
  <div
    class="user-hover-card"
    [style.left.px]="cardPosition.x"
    [style.top.px]="cardPosition.y"
    (mouseenter)="cancelHide()"
    (mouseleave)="onMouseLeave()"
    >
    <div class="card-header">
      <app-profile-avatar
        [fullName]="fullName"
        [profileUrl]="profileUrl"
        widthSize="44px"
        heightSize="44px"
        [userStatusSlug]="statusSlug"
        >
      </app-profile-avatar>
      <div class="card-identity">
        <span class="card-name">{{ fullName }}</span>
        @if (statusLabel) {
          <span class="card-status">{{ statusLabel }}</span>
        }
      </div>
    </div>

    @if (roleName || user?.email) {
      <div class="card-details">
        @if (roleName) {
          <div class="card-detail-row">
            <mat-icon>badge</mat-icon>
            <span>{{ roleName }}</span>
          </div>
        }
        @if (user?.email) {
          <div class="card-detail-row">
            <mat-icon>mail</mat-icon>
            <a [appEmailCompose]="user.email" [matTooltip]="user.email">{{ user.email }}</a>
          </div>
        }
      </div>
    }
  </div>
}
